module.exports = __webpack_public_path__ + "static/media/download-zip.b9c852d5.svg";